import { render, staticRenderFns } from "./MdoryDataTable.vue?vue&type=template&id=314c1cf4&"
import script from "./MdoryDataTable.vue?vue&type=script&lang=js&"
export * from "./MdoryDataTable.vue?vue&type=script&lang=js&"
import style0 from "./MdoryDataTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MdoryDataTable.vue"
export default component.exports